export default "__VITE_ASSET__DCVc85yk__"